import { put, select } from 'typed-redux-saga/macro';

import marketingAttribution from 'Lib/Session';
import { dateToEpochSeconds } from 'Lib/utils/dateTime';

import { getThemeIdOrLight } from 'Store/appSettings/selectors';
import { ThemeId } from 'Store/appSettings/types';
import { getExperience } from 'Store/context/selectors';
import { getLocationPermission } from 'Store/location/selectors';
import { getBirthday } from 'Store/profile/selectors';
import { getRouteParams } from 'Store/routing/selectors';

import { trackEvent } from 'Store/sparks/actions';
import { APP_OPEN } from 'Store/sparks/sparks.events';

export function* handleLogAppOpen() {
  marketingAttribution.init();
  const theme = yield* select(getThemeIdOrLight);
  const birthday = yield* select(getBirthday);

  const locationPermission = yield* select(getLocationPermission);
  const deviceDarkModePreference = window.matchMedia(`(prefers-color-scheme: dark)`).matches;
  const appDarkModePreference = theme === ThemeId.Dark;

  const source = yield* select(getExperience);

  const routeParams = yield* select(getRouteParams);
  const referralURL = source && routeParams?.id;

  yield* put(
    trackEvent(APP_OPEN, {
      birthDate: birthday != null ? dateToEpochSeconds(birthday) : null,
      locationPermission,
      appDarkModePreference,
      deviceDarkModePreference,
      referralURL,
      source,
    })
  );
}
